import { elegir } from '../ui/layout-variant.tsx';
import { CuerpoMobile } from './Cuerpo.mobile.tsx';
import { CuerpoDesktop } from './Cuerpo.desktop.tsx';

export default elegir(CuerpoMobile, CuerpoDesktop);
